(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camarg-property-listings"] && !Shopify.designMode) return;
  try {
    
/**
 * CAMARG ESTATES — client-side property filters (no dependencies)
 */
(function () {
  'use strict';

  var SELECTOR_ROOT = '[data-camarg-property-listings]';
  var SELECTOR_CARD = '[data-camarg-pl-card]';
  var SELECTOR_CARDS = '[data-camarg-pl-cards]';
  var SELECTOR_EMPTY = '[data-camarg-pl-empty]';
  var ATTR_TYPE = 'data-type';
  var ATTR_LOCATION = 'data-location';
  var ATTR_LISTING_TYPE = 'data-listing-type';
  var ATTR_COLLECTIONS = 'data-collections';
  var ATTR_CATEGORY = 'data-category';
  var ATTR_PRICE = 'data-price';
  var ATTR_AREA = 'data-area';
  var ATTR_ROOMS = 'data-rooms';
  var ATTR_FEATURES = 'data-features';

  function parseNum(value) {
    if (value === null || value === undefined || value === '') return null;
    var n = parseFloat(String(value).replace(/[^\d.,-]/g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function getFeaturesSet(card) {
    var raw = card.getAttribute(ATTR_FEATURES) || '';
    if (!raw.trim()) return new Set();
    return new Set(
      raw.split(',').map(function (s) {
        return s.trim().toLowerCase();
      }).filter(Boolean)
    );
  }

  function includesInsensitive(haystack, needle) {
    if (!needle) return true;
    return String(haystack || '').toLowerCase().indexOf(needle.toLowerCase().trim()) !== -1;
  }

  function listingFilterMatches(cardListing, filterVal) {
    if (!filterVal) return true;
    var want = String(filterVal).trim().toLowerCase();
    if (!want) return true;
    var have = String(cardListing || '')
      .trim()
      .toLowerCase();
    return have === want;
  }

  function collectionFilterMatches(collectionsAttr, wantHandle) {
    if (!wantHandle) return true;
    var h = String(wantHandle).trim().toLowerCase();
    if (!h) return true;
    var parts = String(collectionsAttr || '')
      .split(',')
      .map(function (p) {
        return p.trim().toLowerCase();
      })
      .filter(Boolean);
    return parts.indexOf(h) !== -1;
  }

  function categoryFilterMatches(cardCategory, filterVal) {
    if (!filterVal) return true;
    return includesInsensitive(String(cardCategory || ''), String(filterVal).trim());
  }

  function initGalleries(root) {
    root.querySelectorAll('[data-camarg-gallery]:not([data-camarg-gallery-ready])').forEach(function (wrap) {
      var dataEl = wrap.querySelector('script.camarg-pl__gallery-data, .camarg-pl__gallery-data');
      var img = wrap.querySelector('[data-camarg-gallery-img]');
      var prev = wrap.querySelector('[data-camarg-gallery-prev]');
      var next = wrap.querySelector('[data-camarg-gallery-next]');
      if (!dataEl || !img) return;
      var urls;
      try {
        urls = JSON.parse((dataEl.textContent || '').trim());
      } catch (e) {
        return;
      }
      if (!urls || !urls.length || urls.length < 2) return;

      wrap.setAttribute('data-camarg-gallery-ready', 'true');

      var idx = parseInt(wrap.getAttribute('data-camarg-gallery-initial-index') || '0', 10);
      if (isNaN(idx) || idx < 0) idx = 0;
      if (idx >= urls.length) idx = 0;

      function showAt(i) {
        var len = urls.length;
        idx = ((i % len) + len) % len;
        img.removeAttribute('srcset');
        img.sizes = '';
        img.src = urls[idx];
      }

      showAt(idx);

      function onPrev(e) {
        e.preventDefault();
        e.stopPropagation();
        showAt(idx - 1);
      }
      function onNext(e) {
        e.preventDefault();
        e.stopPropagation();
        showAt(idx + 1);
      }
      if (prev) prev.addEventListener('click', onPrev);
      if (next) next.addEventListener('click', onNext);
    });
  }

  function readFilters(root) {
    var type = '';
    var loc = '';
    var priceMin = null;
    var priceMax = null;
    var areaMin = null;
    var areaMax = null;
    var rooms = null;
    var featuresRequired = [];

    var typeInput = root.querySelector('[data-camarg-filter="type"]');
    if (typeInput) type = typeInput.value || '';

    var listingInput = root.querySelector('[data-camarg-filter="listing"]');
    var listing = listingInput ? listingInput.value || '' : '';

    var locInput = root.querySelector('[data-camarg-filter="location"]');
    if (locInput) {
      loc = locInput.value || '';
      if (loc === 'other') {
        loc = '';
      }
    }

    var colInput = root.querySelector('[data-camarg-filter="collection"]');
    var collection = colInput ? colInput.value || '' : '';

    var catInput = root.querySelector('[data-camarg-filter="category"]');
    var category = catInput ? catInput.value || '' : '';

    var pmin = root.querySelector('[data-camarg-filter="price_min"]');
    if (pmin && pmin.value !== '') priceMin = parseNum(pmin.value);
    var pmax = root.querySelector('[data-camarg-filter="price_max"]');
    if (pmax && pmax.value !== '') priceMax = parseNum(pmax.value);

    var amin = root.querySelector('[data-camarg-filter="area_min"]');
    if (amin && amin.value !== '') areaMin = parseNum(amin.value);
    var amax = root.querySelector('[data-camarg-filter="area_max"]');
    if (amax && amax.value !== '') areaMax = parseNum(amax.value);

    var roomsInput = root.querySelector('[data-camarg-filter="rooms"]');
    if (roomsInput && roomsInput.value !== '') rooms = parseNum(roomsInput.value);

    var featureInputs = root.querySelectorAll('input[type="checkbox"][data-camarg-feature]');
    featureInputs.forEach(function (el) {
      if (el.checked) {
        var key = (el.getAttribute('data-camarg-feature') || '').toLowerCase();
        if (key) featuresRequired.push(key);
      }
    });

    return {
      type: type,
      listing: listing,
      location: loc,
      collection: collection,
      category: category,
      priceMin: priceMin,
      priceMax: priceMax,
      areaMin: areaMin,
      areaMax: areaMax,
      rooms: rooms,
      features: featuresRequired
    };
  }

  function cardMatches(card, f) {
    var type = card.getAttribute(ATTR_TYPE) || '';
    var loc = card.getAttribute(ATTR_LOCATION) || '';
    var listing = card.getAttribute(ATTR_LISTING_TYPE) || '';
    var collections = card.getAttribute(ATTR_COLLECTIONS) || '';
    var category = card.getAttribute(ATTR_CATEGORY) || '';
    var price = parseNum(card.getAttribute(ATTR_PRICE));
    var area = parseNum(card.getAttribute(ATTR_AREA));
    var rooms = parseNum(card.getAttribute(ATTR_ROOMS));
    var featSet = getFeaturesSet(card);

    if (f.type && !includesInsensitive(type, f.type)) return false;
    if (f.listing && !listingFilterMatches(listing, f.listing)) return false;
    if (f.location && !includesInsensitive(loc, f.location)) return false;
    if (f.collection && !collectionFilterMatches(collections, f.collection)) return false;
    if (f.category && !categoryFilterMatches(category, f.category)) return false;

    if (f.priceMin !== null && (price === null || price < f.priceMin)) return false;
    if (f.priceMax !== null && (price === null || price > f.priceMax)) return false;

    if (f.areaMin !== null && (area === null || area < f.areaMin)) return false;
    if (f.areaMax !== null && (area === null || area > f.areaMax)) return false;

    if (f.rooms !== null && (rooms === null || rooms < f.rooms)) return false;

    for (var i = 0; i < f.features.length; i++) {
      if (!featSet.has(f.features[i])) return false;
    }

    return true;
  }

  function applyFilter(root) {
    var container = root.querySelector(SELECTOR_CARDS);
    if (!container) return;

    var emptyEl = root.querySelector(SELECTOR_EMPTY);
    var cards = container.querySelectorAll(SELECTOR_CARD);
    var filters = readFilters(root);
    var visible = 0;

    cards.forEach(function (card) {
      if (cardMatches(card, filters)) {
        card.hidden = false;
        visible++;
      } else {
        card.hidden = true;
      }
    });

    if (emptyEl) {
      if (visible === 0) {
        emptyEl.hidden = false;
        emptyEl.removeAttribute('hidden');
      } else {
        emptyEl.hidden = true;
        emptyEl.setAttribute('hidden', 'hidden');
      }
    }
  }

  function clearFilters(root) {
    var typeInput = root.querySelector('[data-camarg-filter="type"]');
    if (typeInput) typeInput.value = '';
    var listingInput = root.querySelector('[data-camarg-filter="listing"]');
    if (listingInput) listingInput.value = '';
    var locInput = root.querySelector('[data-camarg-filter="location"]');
    if (locInput) locInput.value = '';
    var colInput = root.querySelector('[data-camarg-filter="collection"]');
    if (colInput) colInput.value = '';
    var catInput = root.querySelector('[data-camarg-filter="category"]');
    if (catInput) catInput.value = '';
    ['price_min', 'price_max', 'area_min', 'area_max', 'rooms'].forEach(function (k) {
      var el = root.querySelector('[data-camarg-filter="' + k + '"]');
      if (el) el.value = '';
    });
    var checks = root.querySelectorAll('input[type="checkbox"][data-camarg-feature]');
    checks.forEach(function (c) {
      c.checked = false;
    });
    applyFilter(root);
  }

  function isFilterOverlayUi(ui) {
    // „modal“ — legacy; Liquid вече нормализира към sheet
    return ui === 'sheet' || ui === 'modal';
  }

  function initMobileFilters(root) {
    if (root.getAttribute('data-camarg-mf-js') === '1') {
      return;
    }
    var mf = (root.getAttribute('data-camarg-mf-ui') || 'inline').toLowerCase();
    var df = (root.getAttribute('data-camarg-df-ui') || 'sidebar').toLowerCase();
    if (!isFilterOverlayUi(mf) && !isFilterOverlayUi(df)) {
      return;
    }
    var openBtn = root.querySelector('[data-camarg-mf-open]');
    var closeBtn = root.querySelector('[data-camarg-mf-close]');
    var backdrop = root.querySelector('[data-camarg-mf-backdrop]');
    var panel = root.querySelector('[data-camarg-mf-panel]');
    if (!openBtn || !panel) {
      return;
    }
    root.setAttribute('data-camarg-mf-js', '1');

    var mqlNarrow = window.matchMedia('(max-width: 989px)');

    function getEffectiveFilterUi() {
      return mqlNarrow.matches ? mf : df;
    }

    function useFilterOverlay() {
      return isFilterOverlayUi(getEffectiveFilterUi());
    }

    function setOpen(visible) {
      if (!useFilterOverlay()) {
        root.classList.remove('camarg-pl--mf-open');
        document.body.classList.remove('camarg-pl--mf-locked');
        openBtn.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.setAttribute('aria-hidden', 'false');
        }
        return;
      }
      root.classList.toggle('camarg-pl--mf-open', visible);
      document.body.classList.toggle('camarg-pl--mf-locked', visible);
      openBtn.setAttribute('aria-expanded', visible ? 'true' : 'false');
      if (panel) {
        panel.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
    }

    function close() {
      setOpen(false);
    }

    function openPanel() {
      setOpen(true);
    }

    function onViewportModeChange() {
      setOpen(false);
      if (panel) {
        panel.setAttribute('aria-hidden', useFilterOverlay() ? 'true' : 'false');
      }
    }

    openBtn.setAttribute('aria-expanded', 'false');
    if (panel) {
      panel.setAttribute('aria-hidden', useFilterOverlay() ? 'true' : 'false');
    }

    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (root.classList.contains('camarg-pl--mf-open')) {
        close();
      } else {
        openPanel();
      }
    });
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    }
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        close();
      });
    }
    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape' || !useFilterOverlay()) {
        return;
      }
      if (root.classList.contains('camarg-pl--mf-open')) {
        close();
      }
    });
    if (mqlNarrow.addEventListener) {
      mqlNarrow.addEventListener('change', onViewportModeChange);
    } else if (mqlNarrow.addListener) {
      mqlNarrow.addListener(onViewportModeChange);
    }
  }

  function initInquiryModal(root) {
    if (root.getAttribute('data-camarg-inquire-js') === '1') {
      return;
    }
    var inquireRoot = root.querySelector('[data-camarg-inquire-root]');
    if (!inquireRoot) {
      return;
    }
    var dialog = root.querySelector('[data-camarg-inquire-dialog]');
    if (!dialog) {
      return;
    }
    var form =
      inquireRoot.querySelector('form.camarg-pl__inquire-form') ||
      inquireRoot.querySelector('form[action*="contact"]') ||
      inquireRoot.querySelector('form');

    var lastFocus = null;
    var backdrop = inquireRoot.querySelector('[data-camarg-inquire-backdrop]');

    function readOpenData(btn) {
      return {
        title:
          btn.getAttribute('data-camarg-inquire-title') ||
          (btn.dataset && btn.dataset.camargInquireTitle) ||
          '',
        loc:
          btn.getAttribute('data-camarg-inquire-location') ||
          (btn.dataset && btn.dataset.camargInquireLocation) ||
          '',
        area:
          btn.getAttribute('data-camarg-inquire-area') ||
          (btn.dataset && btn.dataset.camargInquireArea) ||
          '',
        price:
          btn.getAttribute('data-camarg-inquire-price') ||
          (btn.dataset && btn.dataset.camargInquirePrice) ||
          '',
        url:
          btn.getAttribute('data-camarg-inquire-url') ||
          (btn.dataset && btn.dataset.camargInquireUrl) ||
          ''
      };
    }

    function getSummaryEls() {
      return {
        title: dialog.querySelector('[data-camarg-inquire-summary-title]'),
        location: dialog.querySelector('[data-camarg-inquire-summary-location]'),
        area: dialog.querySelector('[data-camarg-inquire-summary-area]'),
        price: dialog.querySelector('[data-camarg-inquire-summary-price]')
      };
    }

    function setLine(el, text) {
      if (!el) return;
      if (text) {
        el.textContent = text;
        el.style.display = '';
      } else {
        el.textContent = '';
        el.style.display = 'none';
      }
    }

    function openInquiry(btn) {
      var d = readOpenData(btn);
      var title = d.title;
      var loc = d.loc;
      var area = d.area;
      var price = d.price;
      var url = d.url;
      lastFocus = document.activeElement;
      var sum = getSummaryEls();
      setLine(sum.title, title);
      setLine(sum.location, loc);
      if (area) {
        var a = String(area);
        if (/кв|m²|m2|м\./i.test(a)) {
          setLine(sum.area, 'Площ: ' + a);
        } else {
          setLine(sum.area, 'Площ: ' + a + ' кв. м');
        }
      } else {
        setLine(sum.area, '');
      }
      setLine(sum.price, price && price !== '—' ? 'Цена: ' + price : '');

      inquireRoot.dataset.inqUrl = url;
      inquireRoot.dataset.inqTitle = title;

      inquireRoot.hidden = false;
      dialog.setAttribute('aria-hidden', 'false');
      document.body.classList.add('camarg-pl--inquire-locked');
      var nameInput = (form && form.querySelector('[data-camarg-inquire-name]')) || dialog.querySelector('[data-camarg-inquire-name]');
      if (nameInput) {
        setTimeout(function () {
          nameInput.focus();
        }, 20);
      }
    }

    function closeInquiry() {
      inquireRoot.hidden = true;
      dialog.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('camarg-pl--inquire-locked');
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try {
          lastFocus.focus();
        } catch (err) {
          void err;
        }
      }
    }

    root.addEventListener(
      'click',
      function (e) {
        var openBtn = e.target && e.target.closest && e.target.closest('[data-camarg-inquire-open]');
        if (openBtn && root.contains(openBtn)) {
          e.preventDefault();
          openInquiry(openBtn);
          return;
        }
        if (backdrop && e.target === backdrop) {
          e.preventDefault();
          closeInquiry();
          return;
        }
        var closeEl = e.target && e.target.closest && e.target.closest('[data-camarg-inquire-close]');
        if (closeEl && root.contains(closeEl)) {
          e.preventDefault();
          closeInquiry();
        }
      },
      true
    );

    if (form) {
      form.addEventListener('submit', function (e) {
        var gdpr = form.querySelector('[data-camarg-inquire-gdpr]');
        if (!gdpr || !gdpr.checked) {
          e.preventDefault();
          return;
        }
        var name = (form.querySelector('[data-camarg-inquire-name]') || {}).value || '';
        var email = (form.querySelector('[data-camarg-inquire-email]') || {}).value || '';
        var phone = (form.querySelector('[data-camarg-inquire-phone]') || {}).value || '';
        var message = (form.querySelector('[data-camarg-inquire-message]') || {}).value || '';
        var body = form.querySelector('[data-camarg-inquire-body]');
        if (!body) {
          e.preventDefault();
          return;
        }
        var lines = [];
        lines.push('Запитване за имот (списък имоти CAMARG)');
        lines.push('Имот: ' + (inquireRoot.dataset.inqTitle || '—'));
        lines.push('Линк: ' + (inquireRoot.dataset.inqUrl || '—'));
        lines.push('— — —');
        lines.push('Име: ' + name.trim());
        lines.push('Имейл: ' + email.trim());
        if (phone.trim()) {
          lines.push('Телефон: ' + phone.trim());
        }
        lines.push('— — —');
        lines.push('Съобщение:');
        lines.push(message.trim() || '(празно)');
        lines.push('— — —');
        lines.push('GDPR: съгласие за обработка на лични данни във връзка с това запитване.');
        body.value = lines.join('\n');
      });
    }

    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape' || inquireRoot.hidden) {
        return;
      }
      closeInquiry();
    });

    root.setAttribute('data-camarg-inquire-js', '1');
  }

  function initSection(root) {
    initGalleries(root);
    initMobileFilters(root);
    initInquiryModal(root);
    if (root.getAttribute('data-camarg-pl-initialized') === 'true') {
      return;
    }
    var cardsHost = root.querySelector(SELECTOR_CARDS);
    var hasFilters = !!root.querySelector('[data-camarg-pl-filters]');
    var hasInquire = !!root.querySelector('[data-camarg-inquire-root]');
    if (!cardsHost && !hasFilters && !hasInquire) {
      return;
    }
    root.setAttribute('data-camarg-pl-initialized', 'true');

    var onChange = function () {
      applyFilter(root);
    };

    root.addEventListener('input', function (e) {
      if (e.target && e.target.getAttribute('data-camarg-filter') && e.target.getAttribute('data-camarg-filter') !== 'feature') {
        onChange();
      }
    });
    root.addEventListener('change', function (e) {
      if (e.target && (e.target.getAttribute('data-camarg-filter') || e.target.getAttribute('data-camarg-feature'))) {
        onChange();
      }
    });

    function closeMobileFilterPanel() {
      var mf0 = (root.getAttribute('data-camarg-mf-ui') || 'inline').toLowerCase();
      var df0 = (root.getAttribute('data-camarg-df-ui') || 'sidebar').toLowerCase();
      var n = window.matchMedia('(max-width: 989px)').matches ? mf0 : df0;
      if (n !== 'sheet' && n !== 'modal') {
        return;
      }
      root.classList.remove('camarg-pl--mf-open');
      document.body.classList.remove('camarg-pl--mf-locked');
      var ob = root.querySelector('[data-camarg-mf-open]');
      var pn = root.querySelector('[data-camarg-mf-panel]');
      if (ob) {
        ob.setAttribute('aria-expanded', 'false');
      }
      if (pn) {
        pn.setAttribute('aria-hidden', 'true');
      }
    }

    var applyBtn = root.querySelector('[data-camarg-pl-apply]');
    if (applyBtn) {
      applyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        onChange();
        closeMobileFilterPanel();
      });
    }
    var clearBtn = root.querySelector('[data-camarg-pl-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        clearFilters(root);
        closeMobileFilterPanel();
      });
    }

    if (cardsHost) {
      applyFilter(root);
    }
  }

  function initAll() {
    document.querySelectorAll(SELECTOR_ROOT).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev || !ev.target) return;
    var sec = ev.target;
    if (sec.matches && sec.matches(SELECTOR_ROOT)) {
      initSection(sec);
    } else {
      var inner = sec.querySelector(SELECTOR_ROOT);
      if (inner) initSection(inner);
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
